import type { HotelsLocale } from './en'

export const hotelsKo = {
  nav: {
    dashboard: '대시보드',
    settings: '설정',
    wakeupScheduling: '모닝콜 예약',
    wakeupHistory: '모닝콜 이력',
  },
  common: {
    unknown: '알 수 없음',
    notAvailable: '해당 없음',
    placeholder: '—',
    search: '검색',
    entries: '개 항목',
    show: '표시',
    retry: '다시 시도',
    loading: '불러오는 중',
    previous: '이전',
    next: '다음',
    dayPlaceholder: '요일...',
    timePlaceholder: '시간...',
    filterTimesPlaceholder: '시간 필터...',
  },
  dialogs: {
    confirm: '확인',
    cancel: '취소',
  },
  errors: {
    loadRooms: '객실을 불러오지 못했습니다',
    loadWakeupHistory: '모닝콜 이력을 불러오지 못했습니다',
    loadPbxSettings: 'PBX 설정을 불러오지 못했습니다',
    loadExtensions: '내선을 불러오지 못했습니다',
  },
  pagination: {
    previousPage: '이전 페이지',
    nextPage: '다음 페이지',
    resultsPerPage: '페이지당 결과:',
    all: '전체',
    jumpToPage: '{{page}}페이지로 이동',
    recordRange: '{{start}}—{{end}} / 총 {{total}}개',
    recordRangeEmpty: '0 / 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}}개 항목',
    entriesFiltered: '{{total}}개 중 {{filtered}}개',
    resultsPerPage: '페이지당 결과:',
    showingSummary: '{{count}}개 중 {{start}}-{{end}} 표시',
  },
  datePresets: {
    today: '오늘',
    tomorrow: '내일',
    yesterday: '어제',
    '1week': '1주',
    '2weeks': '2주',
    '3weeks': '3주',
    '4weeks': '4주',
    all: '전체',
  },
  wakeupStatus: {
    scheduled: '예약됨',
    tried: '시도됨',
    cleared: '삭제됨',
    canceled: '취소됨',
  },
  dashboard: {
    incomingCallHistory: '수신 통화 기록',
    emergencyHistory: '911 기록 (7일)',
    roomStatus: '객실 상태',
    searchCalls: '통화 검색...',
    noIncomingCalls: '수신 통화가 없습니다',
    noMatchingCalls: '검색 결과가 없습니다',
    number: '번호',
    name: '이름',
    time: '시간',
    destination: '대상',
    room: '객실',
    timeAndDate: '일시',
    duration: '통화 시간',
    noEmergencyCalls: '통화 없음',
    emergencyFooter: '* {{destination}}로 통화됨',
    refreshingIn: '{{seconds}}초 후 새로고침',
    noRoomsTitle: '객실이 없습니다',
    noRoomsDescription: '이 PBX에는 호텔 객실이 설정되어 있지 않습니다.',
    resetRoomsSuccess: '{{count}}개 객실이 Dirty로 초기화되었습니다',
    resetRoomsFailed: '객실 초기화에 실패했습니다',
    roomStatusActions: {
      dirty: 'Dirty',
      clean: 'Clean',
      occupied: 'Occupied',
      inspected: 'Inspected',
    },
    roomTile: {
      openAria: '객실 {{room}} 열기',
    },
    roomDetail: {
      title: '객실 {{room}}',
      changeStatus: '상태 변경',
      cleanOrInspectedWarning:
        'Clean 또는 Inspected로 변경하면 활성 모닝콜이 취소되고 음성메시지가 삭제됩니다.',
      activeWakeups: '활성 모닝콜',
      voicemails: '음성메시지',
      statusUpdated: '객실 상태가 업데이트되었습니다',
      statusUpdateFailed: '객실 상태 업데이트에 실패했습니다',
    },
    resetAllRooms: {
      button: '모든 객실을 Dirty로 초기화',
      title: '모든 객실 초기화',
      description:
        '모든 객실이 Dirty 상태로 변경됩니다. 모닝콜과 음성메시지는 영향받지 않습니다. 계속하시겠습니까?',
      confirm: '전체 초기화',
    },
    wakeupPopover: {
      title: '모닝콜',
      manageAria: '모닝콜 관리',
      manageAriaPending: '모닝콜 관리 (대기 중)',
      manageAriaCleared: '모닝콜 관리 (삭제됨)',
      clearAll: '전체 삭제?',
      clearAllSuccess: '{{count}}개의 모닝콜{{suffix}}이 취소되었습니다',
      clearAllFailed: '모닝콜 삭제에 실패했습니다',
      scheduleSuccess: '모닝콜이 예약되었습니다',
      scheduleFailed: '모닝콜 예약에 실패했습니다',
      addAria: '모닝콜 추가',
      loading: '불러오는 중...',
      none: '활성 모닝콜이 없습니다',
      schedule: '일정',
      cancelAria: '모닝콜 취소',
      cancelAriaWithTime: '{{time}} 모닝콜 취소',
    },
    voicemailPopover: {
      title: '음성메시지',
      manageAria: '음성메시지 관리',
      manageAriaWithCount_one: '음성메시지 관리 ({{count}}개)',
      manageAriaWithCount_other: '음성메시지 관리 ({{count}}개)',
      clearAll: '전체 삭제?',
      clearAllSuccess_one: '{{count}}개의 음성메시지가 삭제되었습니다',
      clearAllSuccess_other: '{{count}}개의 음성메시지가 삭제되었습니다',
      clearAllFailed: '음성메시지 전체 삭제에 실패했습니다',
      loading: '불러오는 중...',
      none: '음성메시지가 없습니다',
      status: '상태',
      received: '수신 시각',
      from: '발신자',
      read: '읽음',
      new: '새 메시지',
      deleteAria: '음성메시지 삭제',
      deleteSuccess: '음성메시지가 삭제되었습니다',
      deleteFailed: '음성메시지 삭제에 실패했습니다',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}}개의 모닝콜{{suffix}}이 예약되었습니다',
    scheduleFailed: '모닝콜 예약에 실패했습니다',
    selectDate: '날짜 선택',
    selectTime: '시간 선택',
    scheduleWakeupCalls: '모닝콜 예약',
    scheduling: '예약 중...',
    selectedRooms: '{{count}}개 객실{{suffix}} 선택됨',
    cancelSuccess: '모닝콜이 취소되었습니다',
    cancelFailed: '모닝콜 취소에 실패했습니다',
    addToPendingAria: '대기 중 변경에 추가',
    pendingChanges: '대기 중 변경',
    noPendingChanges: '대기 중 변경 사항이 없습니다',
    applyChanges: '변경 적용',
    reset: '초기화',
    noMatchingRooms: '일치하는 객실이 없습니다',
    noRoomsAvailable: '사용 가능한 객실이 없습니다',
    roomNumber: '객실 번호',
    roomName: '객실 이름',
    status: '상태',
    currentSchedule: '현재 일정',
    selectAllRooms: '모든 객실 선택',
    selectRoom: '객실 {{number}} 선택',
    dayLabel: '요일',
    timeLabel: '시간',
    filterTimesLabel: '시간 필터',
    removePendingAria: '객실 {{room}}의 대기 중인 모닝콜 제거, {{time}}',
    cancelWakeupAria: '객실 {{room}}의 {{time}} 모닝콜 취소',
  },
  history: {
    noHistory: '모닝콜 이력이 없습니다',
    noMatchingRecords: '일치하는 기록이 없습니다',
    showing: '{{count}}개 중 {{start}}~{{end}} 표시',
    filteredFromTotal: '(전체 {{total}}개에서 필터됨)',
    room: '객실',
    roomName: '객실 이름',
    attempts: '시도 횟수',
    wakeupDateTime: '모닝콜 날짜 및 시간',
    activationDateTime: '활성화 날짜 및 시간',
    wakeupStatus: '모닝콜 상태',
    originator: '발신 주체',
    originPhone: '전화',
    originPortal: '포털',
  },
  settings: {
    activation: '활성화',
    searchRoomsOrNames: '객실 번호 또는 이름으로 검색...',
    noMatchingExtensions: '검색과 일치하는 내선이 없습니다',
    noExtensionsForPbx: '이 PBX에 대한 내선 라인이 없습니다',
    active: '활성',
    roomNumber: '객실 번호',
    extensionName: '내선 이름',
    currentStatus: '현재 상태',
    roomActiveAria: '객실 {{number}} 활성',
    statusAtTime: '{{status}} ({{date}} {{time}})',
    activated: '활성화됨',
    deactivated: '비활성화됨',
    roomToggleStatus: '객실 {{roomNumber}} {{action}}',
    toggleHospitalityFailed: '호텔 모드 전환에 실패했습니다',
    resetRoomsToDirty: '객실을 Dirty로 초기화',
    everyDayAt: '매일',
    manually: '수동',
    saveSchedule: '저장',
    scheduleSaveFailed: '초기화 일정 업데이트에 실패했습니다',
    manualResetEnabled: '객실 상태가 수동으로 초기화됩니다',
    dailyResetAt: '객실 상태가 매일 {{time}}에 초기화됩니다',
  },
} satisfies HotelsLocale
